/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { getUTCTimeStampMMDDYYYY } from '../../../../SharedModules/DateUtilities/DateUtilities';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';

import {
  addParticipationDate,
  deleteGroup,
  deleteParticipationDate,
  setGroupDataChangeTried,
  updateParticipationDate,
  updateParticipationUserId,
} from '../store/group-action';
import EndDate from './endDate';
import GroupNameCustomComponent from './groupNameCustomComponent';
import StartDate from './startDate';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import ActionColumnRender from './ActionColumnRender';
import {
  checkActionAccessByRole,
  isReadOnly as isRead,
} from '../../../../SharedModules/utilities/utilities';

const MainGroupParticipationDates = (props) => {
  const {
    rowIndex,
    setDisableSaveAndCancel,
    fullScreenView,
    setSucessMessage,
    setFullScreenView,
    disableSaveAndCancel,
    cellHead,
    hasAccessbyRole,
    kcRoles,
    isEnablebyRole,
    isReadOnly,
  } = props;
  const dispatch = useDispatch();

  const particpationDates = useSelector(
    (state) => state.sharedState.GroupReducer.particpationDates
  );
  const groupDetails = useSelector(
    (state) => state.sharedState.GroupReducer.mainGroupDetails
  );
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [corrId, setCorrId] = useState(null);
  const [showComments, setShowComments] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [lastDeletePopup, setLastDeletePopup] = useState(false);
  const [index, setIndex] = useState(null);
  const [selectRow, setSelectRow] = useState({});
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [gridParams, setGridParams] = useState(null);

  const onGridReady = useCallback((params) => {
    setGridParams(params);
  }, []);

  useEffect(() => {
    if (!showComments && corrLinkId) checkCommentsExist();
  }, [showComments]);

  const checkCommentsExist = async () => {
    const currentIndex = particpationDates.findIndex(
      (item) => item.corrLinkId === corrLinkId
    );
    const res = await getExistingCommentLinkIds([corrLinkId]);
    const isExistingComment = res?.includes(corrLinkId) ? 1 : 0;
    dispatch(updateParticipationDate(currentIndex, isExistingComment));
  };

  const getExistingCommentLinkIds = async (idList) => {
    try {
      const response = await axios.post(
        serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS,
        {
          corrLinkId: idList,
        }
      );
      return response.data?.data ?? [];
    } catch (e) {
      return [];
    }
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const handleBlurForDataChange = (compareData, data) => {
    if (data && !data.newRecord) {
      const compareObj = {
        ...(compareData.data && compareData.data[data.index]),
      };

      if (
        data.groupName !== compareObj.groupName ||
        data.clientGroupId.startDt !== compareObj.clientGroupId.startDt ||
        data.endDt !== compareObj.endDt
      ) {
        dispatch(
          updateParticipationUserId(
            rowIndex,
            logInUser,
            getUTCTimeStampMMDDYYYY(new Date())
          )
        );
        data.updateRecord = true;
        data.oldStartDt = compareObj.clientGroupId.startDt;
      } else {
        dispatch(
          updateParticipationUserId(
            rowIndex,
            compareObj.lastUpdateUserId || '',
            compareObj.lastUpdateDt || null
          )
        );
        data.updateRecord = true;
        data.oldStartDt = compareObj.clientGroupId.startDt;
      }
    }
    dispatch(setGroupDataChangeTried(Math.random()));
  };

  const addNewDate = () => {
    const newDate = {
      index: particpationDates.length,
      newRecord: true,
      endDt: null,
      startDt: null,
      groupName: (groupDetails && groupDetails.groupName) || '',
      corrLinkId: null,
      clientGroupId: {
        startDt: null,
      },
      lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
      lastUpdateUserId: logInUser,
    };
    dispatch(addParticipationDate(newDate));
    handleBlurForDataChange();
    setSucessMessage([]);
    setDisableSaveAndCancel(false);
  };
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const onEditingStopped = (params) => {
    setSucessMessage([]);
    if (params && params.value === params.oldValue && disableSaveAndCancel) {
      setDisableSaveAndCancel(true);
    } else {
      setDisableSaveAndCancel(false);
    }
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.clientGroupId;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        CLIENT_ID: `${selectedRow?.clientId}`,
        GROUP_ID: `${selectedRow?.groupId}`,
        START_DT: `${selectedRow?.startDt} 00:00`,
      });
    }
  };

  const handleDeleteRecord = (rowIndex, data, datesList) => {
    if (datesList?.length === 1) {
      setLastDeletePopup(true);
    } else {
      setDeletePopup(true);
    }
    setIndex(data.index);
    setSelectRow(data);
  };

  return (
    <div className="table-container no-border">
      <SaveCancelPopup
        data-testid="handleDelete"
        open={deletePopup}
        title="Delete"
        moduleName="the selected record"
        onConfim={() => {
          dispatch(deleteParticipationDate(index, selectRow));
          setDeletePopup(false);
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />
      <SaveCancelPopup
        data-testid="handleDeleteAll"
        open={lastDeletePopup}
        title="Delete Group"
        content="This will delete the group and all the participation dates"
        onConfim={() => {
          dispatch(deleteGroup(particpationDates));
          setLastDeletePopup(false);
        }}
        onCancel={() => {
          setLastDeletePopup(false);
        }}
        onClose={(reason) => {
          if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
            setLastDeletePopup(false);
          }
        }}
        aria-label="delete"
      />
      <div className="panel tBillPanel-space pb-0">
        <div className="clearfix" />
        <Grid
          rowData={particpationDates.filter((r) => !r.deleted)}
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          columnDefs={cellHead}
          frameworkComponents={{
            DeleteBoxRender: (props) => {
              return (
                <ActionColumnRender
                  {...props}
                  hasAccess={hasAccessbyRole}
                  handleDeleteRecord={handleDeleteRecord}
                  setCorrLinkId={setCorrLinkId}
                  setCorrId={setCorrId}
                  setShowComments={setShowComments}
                  isEnablebyRole={isEnablebyRole}
                />
              );
            },
            StartDate: (props) => {
              return (
                <StartDate
                  {...props}
                  handleBlur={handleBlurForDataChange}
                  isEnablebyRole={isEnablebyRole}
                />
              );
            },
            EndDate: (props) => {
              return (
                <EndDate
                  {...props}
                  handleBlur={handleBlurForDataChange}
                  isEnablebyRole={isEnablebyRole}
                />
              );
            },
            GroupNameCustomComponent: (props) => (
              <GroupNameCustomComponent
                {...props}
                handleBlur={handleBlurForDataChange}
                isEnablebyRole={isEnablebyRole}
                addAction={addNewDate}
              />
            ),
          }}
          gridHeight={fullScreenView ? '100vh' : 350}
          fullScreenView={fullScreenView}
          onCellValueChanged={onEditingStopped}
          handleFullScreenViewClick={handleFullScreenView}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          exportFile
          data-testid="onEditingStopped"
          fileName="Group Participation"
          addTxt={
            checkActionAccessByRole(
              process.env.REACT_APP_HIDE_ACCESS_ROLES,
              kcRoles
            ) && 'Add New Participation Date'
          }
          disableAddAction={
            isReadOnly ||
            !checkActionAccessByRole(
              process.env.REACT_APP_STATE_ONLY_ROLE,
              kcRoles
            )
          }
          addAction={addNewDate}
          handleViewHistory={handleViewHistory}
        />
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CLIENT_GROUP"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={corrId}
        />
      ) : null}
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CLIENT_GROUP"
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default withRouter(MainGroupParticipationDates);
